import { ListGroup as Bs5ListGroup } from 'react-bootstrap5';

export default Bs5ListGroup;
